import styles from "./TitleHeader.module.css"

function TitleHeader () {


  return <div className={styles.title_header}>
    <h1 className={styles.title_text}>FISHWATCH</h1>
  </div>
}

export default TitleHeader